import styled, { css } from 'styled-components';

export const AnimatedLetter = styled.span`
  display: inline-block;
  opacity: 0;
  animation: bounceIn;
  animation-duration: 0.5s;
  animation-delay: ${(props) => props.delayCount / 10}s;
  animation-fill-mode: forwards;
  min-width: 10px;
  margin-top: 1.5rem;
  font-size: 5.5rem;
  font-weight: 600;
  color: #D6D6D6;
  cursor: pointer;
  @media (max-width: 1010px) {
    font-size: 4rem;
  }
  @media (max-width: 924px) {
    font-size: 3.7rem;
  }
  @media (max-width: 737px) {
    font-size: 3.5rem;
    margin: unset;
    margin-top: 1rem;
  }
  @media (max-width: 634px) {
    font-size: 3rem;
    margin: unset;
    margin-top: 0.6rem;
  }
  @media (max-width: 546px) {
    font-size: 2.6rem;
    margin: unset;
  }
  @media (max-width: 558px) {
    font-size: 2.4rem;
  }
  @media (max-width: 500px) {
    font-size: 2.2rem;
  }
  @media (max-width: 416px) {
    font-size: 2rem;
  }
  @media (max-width: 390px) {
    font-size: 1.8rem;
  }
  @media (max-width: 330px) {
    font-size: 1.7rem;
  }
  @media (max-width: 300px) {
    font-size: 1.5rem;
  }
  @media (max-width: 285px) {
    font-size: 1.2rem;
  }
  ${(props) =>
    props.letterClass === 'text-animate-hover' &&
    css`
      animation: unset;
      min-width: 10px;
      display: inline-block;
      animation-fill-mode: both;
      opacity: 1;

      &:hover {
        animation: rubberBand 1s;
        color: #3bcfe3;
      }
    `}
`;
export const AnimatedHeadText = styled.span`
  display: inline-block;
  opacity: 0;
  animation: bounceIn;
  animation-duration: 0.5s;
  animation-delay: ${(props) => props.delayCount / 10}s;
  animation-fill-mode: forwards;
  min-width: 10px;
  font-size: clamp(1.9rem, 5vw, 3.3rem);
  cursor: pointer;

  @media (max-width: 300px) {
    margin: unset;
  }

  ${(props) =>
    props.letterClass === 'text-animate-hover' &&
    css`
      animation: unset;
      min-width: 10px;
      display: inline-block;
      animation-fill-mode: both;
      opacity: 1;

      &:hover {
        animation: rubberBand 1s;
      }
    `}
`;
export const AnimatedLayoutText = styled.span`
  display: inline-block;
  opacity: 0;
  min-width: 10px;
  font-size: clamp(1.9rem, 5vw, 3.3rem);
  cursor: pointer;

  @media (max-width: 300px) {
    margin: unset;
  }

  ${(props) =>
    props.letterClass === 'text-animate-hover' &&
    css`
      animation: unset;
      min-width: 10px;
      display: inline-block;
      animation-fill-mode: both;
      opacity: 1;

      &:hover {
        animation: rubberBand 1s;
      }
    `}
`;

export const Bubble = styled.span`
  position: absolute;
  width: 25%;
  height: 100%;
  background-color: #3bcfe3;
  transform: translateY(150%);
  border-radius: 50%;
  left: calc(
    ${({ count }) => (count !== null ? String(count - 1) : '0')} * 25%
  );
  width: 25%;
  transition: 0.5s;
  transition-delay: ${({ count }) => count && (count - 1) * 0.1}s;
  z-index: -1;
`;

export const AstroBtn = styled.button`
  color: #3bcfe3;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 4px;
  font-family: sans-serif;
  text-decoration: none;
  display: inline-block;
  background: transparent;
  border: none;
  margin-top: 3rem;
  animation: fadeInAnimation 1s 1.8s backwards;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: 0.5s;

  a {
    text-decoration: none;
  }

  &:hover ${Bubble} {
    transform: translateY(0) scale(2);
  }
`;
